



















import { Component, Mixins } from 'vue-property-decorator'
import CookieConsentMixin from '../mixins/CookieConsentMixin'

@Component
export default class CookieConsentCgu extends Mixins(CookieConsentMixin) {
  loading = false
  updateWithLoading () {
    this.loading = true
    setTimeout(() => {
      this.update()
      this.loading = false
    }, 500)
  }
}
